import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['category', 'hint']

  connect () {
    this.update()
  }

  update () {
    const category = this.categoryTarget.value
    this.hintTargets.forEach(hint => {
      hint.hidden = category !== '' && hint.dataset.category !== category
    })
  }
}
